import request from "@/utils/request";

export function getCardList(code) {
  return request({
    url: `egift/order?order_code=${code}`,
    method: "get"
  });
}